import {WinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/WinPresentationController";
import {MonkeysGoldParsedGameData} from "../../server/data/MonkeysGoldParsedGameData";
import {SpineScatterSymbol} from "../../reelstoppresentation/scatterland/SpineScatterSymbol";
import {MonkeysGoldGameModuleConfig} from "../../MonkeysGoldGameModuleConfig";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {TimelineLite} from "gsap";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";

/**
 * Created by Jerker Nord on 2020-08-28.
 */

export class MonkeysGoldBonusGameScatterController extends WinPresentationController {

    private _freespinsLeft:number;

    constructor(indexes:[number, number]) {
        super(indexes, {name : "MonkeysGoldBonusGameScatterController", skippable : false});
    }

    protected parseFeatureGameData(data:MonkeysGoldParsedGameData):void {
        this._freespinsLeft = data.freespinsLeft;
    }

    protected hasWin():boolean {
        if(this._gameData!.nextMode == GameMode.FREESPIN && this._gameData!.addedNumberOfFreespinsThisSpin > 0) {
            return true;
        } else {
            return false;
        }
    }

    protected startWinPresentation():void {
        const activeScatters:SpineScatterSymbol[] = MonkeysGoldGameModuleConfig.monkeysGoldScatterLandView.getAllActiveScatters();
        if(activeScatters.length > 0) {
            const plusOneTL:TimelineLite = new TimelineLite();
            for(let i:number = 0; i < activeScatters.length; i++) {
                plusOneTL.add(() => activeScatters[i].getPlusOneAnimation(), "+=" + 0.4);
                plusOneTL.add(() => SlotGame.keypad.setZeroBetSpinCounter((this._freespinsLeft - activeScatters.length) + (1 + i)));
            }
            plusOneTL.add(() => this.finish(), "+=1.8");
        } else {
            this.finish();
        }
    }

    protected stopWinPresentation(isAborted:boolean):void {
        //Not skippable
    }
}